<template>
  <div class="col-12 p-0">
    <adv-button
      v-if="!isPhoneOrder"
      class="addtoCart"
      v-on:btn-click="buttonClick"
      :disabled="disabled"
      :productId="productId"
      :quantity="quantity"
      :is-listing="isListing"
      :is-variation-group-master="isVariationGroupMaster"
      :attribute-ids-with-stock="getAttributeIdsWithStock"
      v-html="buttonText"
    >
    </adv-button>
    <adv-button
      v-if="isPhoneOrder"
      class="phoneOrderButton"
      v-on:btn-click="openPhoneOrderModal"
      v-html="phoneOrderButtonText"
    >
    </adv-button>
  </div>
</template>

<script>
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import { flatten } from 'lodash-es'
import { mapGetters } from 'vuex'

export default {
  name: 'AdvCartButton',
  components: {
    AdvButton
  },
  mixins: [onlineMixin, cartButtonMixin],
  props: {
    productId: Number,
    quantity: {
      type: Number,
      default: 0
    },
    stock: {
      type: Number,
      default: 1
    },
    unavailable: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    cartLimitReached: {
      type: Boolean,
      default: false
    },
    hasAttributes: {
      type: Boolean,
      default: false
    },
    selectedAttributeId: {
      type: Number,
      default: null
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    showAddToCartBtnText: {
      type: Boolean,
      default: false
    },
    showAddToCartComboBtnText: {
      type: Boolean,
      default: false
    },
    isUnderContactLenses: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    ...mapGetters(['getProductById']),
    productData () {
      return this.getProductById(this.productId)
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    },
    phoneOrderButtonText () {
      if (this.isPhoneOrder) {
        return `<img src="/ui/main/img/phone-call-icon.png" alt="phone" class="phone-icon mr-2" width="30px" height="30px">
                <span>${this.t('product_only_phone_order')}</span>`
      } else {
        return ''
      }
    },
    isPhoneOrder () {
      return this.productData.isPhoneOrder === 1
    }
  },
  methods: {
    buttonClick () {
      if (this.stock <= 0 && (!this.isListing && !this.isVariationGroupMaster)) {
        this.$emit('btn-click-no-stock')
      } else if (this.isListing && this.isVariationGroupMaster) {
        this.$emit('btn-click-variation-master')
      } else {
        this.$emit('btn-click')
      }
    },
    openPhoneOrderModal () {
      window.location.href = this.t('site.phone.order.number')
    }
  }
}
</script>
